import { Navigate, useParams } from 'react-router-dom';
import AdminIVR, { IVR_SETTINGS_PAGES } from './AdminIVR';
import AdminIvrAudio, { IVR_AUDIO_PAGES } from './AdminIvrAudio';

/** /admin/ivr/:page — each IVR Management page at its own address. */
export default function AdminIvrPage() {
  const { page } = useParams();
  if (IVR_AUDIO_PAGES.includes(page)) return <AdminIvrAudio key={page} page={page} />;
  if (IVR_SETTINGS_PAGES.includes(page)) return <AdminIVR section={page} />;
  return <Navigate to="/admin/ivr/field-inputs" replace />;
}
